// src/pages/PriceCalculator.jsx
import React, { useState } from 'react';
import { priceFromPagesYear } from '../utils/pricing';

const wrap = { background:'#F6F4EF', minHeight:'100vh' };
const container = { maxWidth: 620, margin:'0 auto', padding:'20px 16px' };
const input = {
  width:'100%', padding:'10px 12px', border:'1px solid #D1D5DB',
  borderRadius:8, marginBottom:12, fontSize:16, background:'#fff'
};
const btn = {
  display:'inline-block', padding:'10px 16px', borderRadius:12,
  background:'#0b5226', color:'#fff', border:'none', fontWeight:700, cursor:'pointer'
};
const pill = { ...btn, borderRadius:9999 };

export default function PriceCalculator() {
  const [pages, setPages] = useState('');
  const [year, setYear] = useState('');
  const [res, setRes] = useState(null);

  const onCalc = () => {
    const now = new Date().getFullYear();
    const p = Number(pages) || 0;
    const y = Number(year)  || now;
    const { base, age } = priceFromPagesYear(p, y, now); // «скільки нарахуємо»
    const borrow = Math.round(base * 1.15);              // «взяти книгу» = +15%
    setRes({ base, borrow, age });
  };

  return (
    <div style={wrap}>
      <div style={container}>
        <h1 style={{margin:'4px 0 8px'}}>Калькулятор вартості книги</h1>
        <p style={{color:'#374151'}}>
          Вартість книги розраховується від кількості сторінок і року видання.
          Введіть характеристики вашої книги, щоб дізнатися, скільки монет буде зараховано на ваш баланс.
        </p>

        <label>Кількість сторінок</label>
        <input
          style={input}
          type="number"
          inputMode="numeric"
          placeholder="наприклад, 320"
          value={pages}
          onChange={(e) => setPages(e.target.value.replace(/[^\d]/g, '').slice(0,4))}
        />

        <label>Рік видання</label>
        <input
          style={input}
          type="number"
          inputMode="numeric"
          placeholder="наприклад, 2020"
          value={year}
          onChange={(e) => setYear(e.target.value.replace(/[^\d]/g, '').slice(0,4))}
        />

        <button style={pill} onClick={onCalc}>Розрахувати</button>

        {res && (
          <div style={{marginTop:16, background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:16}}>
            <div style={{fontSize:18, fontWeight:800, marginBottom:8}}>Результат</div>
            <div style={{marginBottom:6}}>Вік книги: <b>{res.age}</b> років</div>
            <div style={{marginBottom:6}}>Ми нарахуємо на баланс: <b>{res.base}</b> монет</div>
            <div>Взяти цю книгу коштуватиме: <b>{res.borrow}</b> монет
              <span style={{color:'#6B7280'}}> (це на 15% більше за суму, що нараховується на баланс)</span>
            </div>
          </div>
        )}

        
      </div>
    </div>
  );
}

